import { useRegistrationStore } from '../store/store.ts';

const useInterpolation = () => {
  const { formData, metadata } = useRegistrationStore();

  const replaceVariables = (translation: string) => {
    const variableRegex = /{{\s*(\w+)\s*}}/g;

    return translation.replace(variableRegex, (match, variable) => {
      const value = formData?.[variable] ?? metadata?.[variable] ?? match;

      return value.toString();
    });
  };

  const text = (value?: string | null): string =>
    (typeof value === 'string' ? replaceVariables(value) : '');

  return { text };
};

export default useInterpolation;
